// configurazioni di test, dev, prod

// export const API_ROOT_URL = "http://localhost:8000";
// configurazioni di test, dev, prod

/*
export const baseUrlConfig = {
  development: {
    API_ROOT_URL: "http://192.168.0.88",
  },
  production: {
    API_ROOT_URL: "https://apidemoapp.revengeproject.cloud",
  },
};
*/

export const baseUrlConfig = {
  development: {
    API_ROOT_URL: "https://apidemoapp.revengeproject.cloud",
  },
  production: {
    API_ROOT_URL: "https://apidemoapp.revengeproject.cloud",
  },
};


export const API_BASE_URL_BACKOFFICE = "backoffice";

export const API_BASE_URL_FRONTOFFICE = "frontoffice";

export const API_BASE_URL = "/api/v1";

// production
export const API_KEY = "idzbf:>khJ&<-Hm4uRiw+SI,}>WPqMnlFj5^*+1[LW1,O*N!-#czBA$|?p]}wP#(";

// apy key di test per id 1, role user --> credenziali username: userdemo, password: Userdemo!11
// export const API_KEY = "aaabbb";

// apy key di test per id 2, role admin --> credenziali username: admindemo, password: Admindemo!11
// export const API_KEY = "cccddd";
